export var IMAGECLOUD_HOOK_EVENT;

!function(IMAGECLOUD_HOOK_EVENT) {
    IMAGECLOUD_HOOK_EVENT.BEFORE_IMAGECLOUD_LAYOUT = "beforeImagecloudLayout", IMAGECLOUD_HOOK_EVENT.AFTER_IMAGECLOUD_LAYOUT = "afterImagecloudLayout", 
    IMAGECLOUD_HOOK_EVENT.AFTER_IMAGECLOUD_DRAW = "afterImagecloudDraw";
}(IMAGECLOUD_HOOK_EVENT || (IMAGECLOUD_HOOK_EVENT = {}));

export function setSize(image, longSideLength) {
    image.aspectRatio > 1 ? (image.width = longSideLength, image.height = ~~(longSideLength / image.aspectRatio)) : (image.height = longSideLength, 
    image.width = ~~(longSideLength * image.aspectRatio));
}

export function setSizeByShortSide(image, shortSideLength) {
    image.aspectRatio > 1 ? (image.height = shortSideLength, image.width = ~~(shortSideLength * image.aspectRatio)) : (image.width = shortSideLength, 
    image.height = ~~(shortSideLength / image.aspectRatio));
}
//# sourceMappingURL=util.js.map